import type { HistoricNarRecommendation } from "../../../../../../shared/api/services/historicNar/types";
import { IconCellVariant } from "../../../../../components/custom-table/tableCell/cellTypes/IconCell";
import { HistoricNarIngestionState } from "../../../../../enums/historicNarIngestionState";
import type { NarAgentGridOrgTab } from "../../narAgentGrid/hooks/useNarAgentGridOrgTabs";

export function readVolume(
  analytics: HistoricNarRecommendation["volume_analytics"],
): string {
  const total = analytics?.calc1 ?? analytics?.calc2;
  return typeof total === "number" ? String(total) : "";
}

export function formatScore(score: number | undefined): string {
  if (typeof score !== "number") return "";
  return score <= 1 ? `${Math.round(score * 100)}` : `${Math.round(score)}`;
}

export const showInfoIcon = (status: string | undefined): boolean =>
  [
    HistoricNarIngestionState.TOUCHLESS,
    HistoricNarIngestionState.AGENTIC,
  ].includes(status as HistoricNarIngestionState);

export const generateDisplayTextWithPrefixLabel = (
  row: HistoricNarRecommendation,
  clientOptions: NarAgentGridOrgTab[],
): string => {
  const labels = (ids: string[]) =>
    ids
      .map((id) => clientOptions.find((client) => client.id === id)?.label)
      .filter((label): label is string => Boolean(label));
  const touchless = labels(row.touchless_enabled_for ?? []);
  const agentic = labels(row.agentic_enabled_for ?? []);
  return [
    touchless.length ? `Touchless: ${touchless.join(", ")}` : "",
    agentic.length ? `Agentic: ${agentic.join(", ")}` : "",
  ]
    .filter(Boolean)
    .join(" ● ");
};

export const determineWhichIconToShow = (status: string): IconCellVariant => {
  switch (status) {
    case HistoricNarIngestionState.NEEDS_REVIEW:
      return IconCellVariant.BOX_ARROW_IN_DOWN_RIGHT_RED;
    case HistoricNarIngestionState.WATCHING:
      return IconCellVariant.BOX_ARROW_IN_DOWN_RIGHT_BLUE;
    default:
      return IconCellVariant.EDIT_PENCIL;
  }
};
